import store from "store/store";

export default function validatePerms(perms: string[] = []) {
	const { myProfile } = store.getState().auth;
	const { permissions = [] } = myProfile || {};

	let permissionValid = false;

	permissionValid = permissions.find(el => perms.find(item => item === el))
		? true
		: false;

	return permissionValid;
}
